import React from "react";
import { motion } from "framer-motion";
import "./AboutMore.css";

const AboutUs = () => {
  return (
    <div className="about-container">
      <motion.h1
        className="about-heading"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        “आमच्या विषयी”
      </motion.h1>

      <motion.div
        className="about-card"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4 }}
      >
        <h2>“आमच्या विषयी”</h2>

        <p>
          <span className="highlight-main">
            कै. रघुनाथ रामचंद्र बुरांडे ग्रंथालय
          </span>{" "}
          हे ज्ञान, अध्ययन आणि बौद्धिक विकासाचे समर्पित केंद्र असून याची स्थापना
          दिनांक{" "}
          <span className="highlight-main">
            ०६ जानेवारी २००९
          </span>{" "}
          रोजी कोडोली, ता. पन्हाळा, जि. कोल्हापूर, महाराष्ट्र येथे करण्यात आली.  या ग्रंथालयाची स्थापना
          <span className="highlight-main">
            {" "}श्री. मकरंद जगन्नाथ बुरांडे
          </span>{" "}
          यांनी केले असून, वाचन संस्कृती, संशोधन वृत्ती आणि आजीवन शिक्षणाची जडणघडण करण्याच्या 
          उद्देशाने हे ग्रंथालय सुरू करण्यात आले.
        </p>

        <p>
          ग्रंथालयाची उभारणी व व्यवस्थापन हे शासनाच्या सर्व लागू नियम, अटी आणि मानकांनुसार काटेकोरपणे करण्यात आले आहे.
           ग्रंथालयास{" "}
          <span className="highlight-main">
            ड  दर्जाची मान्यता
          </span>{" "}
         प्राप्त असून, तो शैक्षणिक व शासकीय निकषांचे पालन दर्शवतो. तसेच, ग्रंथालयात CSR मार्गदर्शक 
         तत्त्वांनुसार आवश्यक निधी व कागदपत्रे व्यवस्थित ठेवली जातात. पारदर्शकता, जबाबदारी आणि सातत्यपूर्ण 
         सुधारणा यांसाठी ग्रंथालयात दरवर्षी नियमित लेखापरीक्षण (ऑडिट) केले जाते, यामुळे संसाधने व सेवा यांचे
          शिस्तबद्ध व्यवस्थापन सुनिश्चित होते.
        </p>

        <p>
          स्थापनेपासून आजपर्यंत ग्रंथालयाने विद्यार्थ्यांपासून संशोधकांपर्यंत तसेच सर्वसामान्य नागरिकांच्या शैक्षणिक
           व माहितीविषयक गरजा पूर्ण करण्यासाठी सातत्याने प्रगती केली आहे. विविध विषयांवरील पुस्तके,
            नियतकालिके, वृत्तपत्रे व डिजिटल साधनांचा समृद्ध आणि सुव्यवस्थित संग्रह उपलब्ध असून, हे 
            ग्रंथालय शिक्षण, संशोधन व स्वतंत्र अध्ययनासाठी विश्वासार्ह माहितीचा स्रोत ठरते.
        </p>

        <p>हे ग्रंथालय जिज्ञासा, चिकित्सक विचारसरणी आणि मुक्त विचारांची देवाणघेवाण प्रोत्साहित करणारे वातावरण
           निर्माण करते. विद्यार्थ्यांच्या शैक्षणिक गुणवत्तेला चालना देतानाच वाचनाची सवय आणि बौद्धिक विकास घडवण्यासाठी 
           हे उपयुक्त ठरते.
           </p>

        <p>ग्रंथालय हे कोल्हापूर जिल्हा ग्रंथालय संघ या मान्यताप्राप्त संस्थेचे सदस्य असून, यामुळे संसाधनांचे आदानप्रदान, 
          व्यावसायिक नेटवर्किंग आणि ग्रंथालय व्यवस्थापनातील उत्कृष्ट पद्धतींचा अवलंब सुलभ होतो. 
          </p>

        <p>फक्त पुस्तकांचे भांडार न राहता, हे ग्रंथालय ग्रामीण भागातील एक गतिशील ज्ञानकेंद्र व सामाजिक सेवा संस्था म्हणून 
          कार्यरत आहे. विद्यार्थ्यांपासून युवक, महिला, शेतकरी आणि सर्वसामान्य ग्रामीण नागरिकांपर्यंत सर्वांना सर्वसमावेशक व 
          समतोल माहिती उपलब्ध करून देत, साक्षरता, जागरूकता आणि आजीवन शिक्षण वाढवण्यात ग्रंथालय महत्त्वाची भूमिका बजावते.
           अशा प्रकारे, समाजाच्या शैक्षणिक, सामाजिक आणि बौद्धिक विकासात हे ग्रंथालय मोलाचे योगदान देत आहे.
           </p>

        <h2>“ग्रंथालयाचा इतिहास”</h2>

        <p className="first-para">
          ग्रंथालयाची पायाभरणी ही संस्थापकांचे आजोबा
          <span className="highlight-date">
            {" "}कै. रघुनाथ रामचंद्र बुरांडे
          </span>{" "}
          गुरुजी यांच्या प्रेरणेतून झाली आहे. कोडोली गावातील
          संस्कृत विषयाचे आदरणीय शिक्षक म्हणून त्यांची ओळख होती.
          पुस्तकांवरील त्यांचे अतूट प्रेम व समाजात ज्ञानप्रसार
          करण्याची तळमळ ही त्यांच्या जीवनमूल्यांची ओळख होती.
        </p>

        <p>
          हेच संस्कार व शैक्षणिक मूल्ये त्यांचे नातू
          <span className="highlight-bold">
            {" "}श्री. मकरंद जगन्नाथ बुरांडे (संस्थापक व अध्यक्ष)
          </span>{" "}
          यांना लाभली. यांना सामाजिक कार्याची विशेष आवड होती. 
          आपल्या आजोबांचे ग्रंथालय स्थापनेचे स्वप्न पूर्ण करणे, 
          वाचन संस्कृतीला प्रोत्साहन देणे, सांस्कृतिक मूल्यांचे जतन
           करणे आणि ही बौद्धिक परंपरा पुढे नेणे या उद्देशाने ग्रंथालयाची स्थापना करण्यात आली.
            या ग्रंथालयाचे आधुनिकीकरण ग्रंथालयाचे 
             <span className="highlight-bold">
            {" "}खजिनदार ओंकार बुरांडे
          </span>{" "} यांनी केले.या ग्रंथालयासाठी सुमारे 
          <span className="highlight-bold"> २८ लाख रुपये</span>{" "}
          स्वतःच्या बचतीतून खर्च करण्यात आले. तसेच, या कक्षाच्या विकासासाठी अनेक
           व्यक्ती व स्थानिक संस्थांनीही आपल्या परीने सहकार्य केले. यांच्या योगदानामुळेच 
           ग्रंथालयासाठी स्वतंत्र इमारत व अभ्यासिका उभारणे शक्य झाले.
        </p>
         <p>सुरुवातीला भाड्याच्या छोट्या खोलीत सुरू झालेला हा उपक्रम आज एका प्रशस्त,
           सुसज्ज व स्वतंत्र इमारतीत विकसित झाला आहे आणि मोठ्या प्रमाणावर वाचक व 
           अभ्यासकांना सेवा देत आहे. ज्ञान, संस्कृती आणि सामाजिक बांधिलकीचे प्रतीक म्हणून
            हे ग्रंथालय आजही कार्यरत आहे.</p>
        <p>
          सध्या या ग्रंथालयाचे ५०० पेक्षा अधिक सभासद आहेत. तसेच, १०,००0 पेक्षा
           अधिक मौल्यवान पुस्तकांचा समृद्ध संग्रह येथे उपलब्ध आहे. अभ्यासिका अंतर्गत 
           अभ्यास करणाऱ्या विद्यार्थ्यांपैकी जवळपास १५ ते २० विद्यार्थी सरकारी नोकरीत विविध क्षेत्रात,
            विभागात रुजू झाले आहेत याचा आम्हाला सार्थ अभिमान आहे.
        </p>

         <p>
          आम्हाला अभिमानाने सांगावेसे वाटते की,
          <span className="highlight-bold">
            {" "}महाराष्ट्र शासनाकडून ग्रंथालयास ‘डॉ. बाबासाहेब आंबेडकर उत्कृष्ट ग्रंथालय पुरस्कार’ 
          </span>{" "}प्राप्त झाला आहे.
         </p>

        <h2>“ग्रंथालयाची पायाभूत सुविधा”</h2>

        <ul>
          <li>एकूण क्षेत्रफळ – १९५० चौ.फुट</li>
          <li>इमारत – १५०० चौ.फुट (G+3 RCC बांधकाम)</li>
          <li>बसण्याची क्षमता – ४०</li>
        </ul>

        <h3>“विभाग”</h3>
        <ul>
          <li>•पुस्तक संग्रह</li>
          <li>•सर्वसाधारण वाचन विभाग</li>
          <li>•महिला विभाग</li>
          <li>•बाल विभाग</li>
          <li>•वर्तमानपत्र, मासिके व नियतकालिके</li>
          <li>•स्पर्धा परीक्षा अभ्यासिका</li>
          <li>•ग्रंथपाल विभाग</li>
          <li>•कार्यालय</li>
        </ul>

        <p>
          • ग्रंथालयात सुरक्षेसाठी CCTV व्यवस्था उपलब्ध आहे. <br />
          • अग्निशामक यंत्र व प्रथमोपचार पेटीची सुविधा उपलब्ध आहे. <br />
          • "Dnyandeep Library Solution" या सॉफ्टवेअरद्वारे ग्रंथालय सेवा
          व्यवस्थापित केल्या जातात.
        </p>

        <h2>“संग्रह माहिती”</h2>
        <ul>
          <li>•एकूण पुस्तके – १०,०००+</li>
          <li>•मासिके व नियतकालिके – ३५</li>
          <li>•वर्तमानपत्रे – ८</li>
        </ul>

        <p>
          ग्रंथालयात दुर्मिळ नाणी, नोटा, तिकीटे व भारतासह परदेशातील ऐतिहासिक
          महत्त्वाच्या वस्तूंचा विशेष संग्रह आहे. तसेच २०० वर्षांपेक्षा जुनी
          हस्तलिखिते जतन केलेली आहेत.
        </p>
      </motion.div>
    </div>
  );
};

export default AboutUs;